export const ProcessingStatusTooltip =
    'It indicates the processing status for the uploaded file from upstream systems. Please ensure to check if there’s any error incurred from your file once it’s processed completely.';
export const ErrorLabelTooltip =
    'It indicates the failure from your data which is provided by upstream systems. Please click "error(s)" to see the details. The correction is required on your end.';
export const FileReceiptTooltip =
    'It indicates the status (check-mark) if your uploaded file has reached the server (upstream system).';
export const UpstreamSystemTooltip =
    "It's the end system which processes the uploaded file and reflects errors if incurred.";
export const DISALLOWED_BULKUPLOAD_COLUMNS = {
    'Error Description (Please remove this column after correcting the file)': true,
};
